import React, { useMemo } from 'react';
import AuctionItem from '../AuctionItem/AuctionItem';
import Spinner from '../Spinner/Spinner';
import { useAuth } from '../../context/AuthContext';
import { ProjectsByAuctionProvider } from '../../context/ProjectsByAuctionContext';

const AuctionList = ({
  auctions,
  totalResults,
  pageSize,
  pageIndex,
  onPageChange,
  loading,
  auctionType,
}) => {
  const auctionList = Array.isArray(auctions) ? auctions : [];
  const { hasActiveSubscription } = useAuth();

  // Collect every auctionId visible on this page so the provider can batch-fetch their projects.
  // Only subscribers see ProjectBadge, so we skip the batch for free users entirely.
  const auctionIds = useMemo(
    () => auctionList
      .map((a) => a.auctionId || a.caNoticeId || a.noticeId)
      .filter(Boolean),
    [auctionList],
  );

  return (
    <div className="w-full">
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12">
          <Spinner />
          <p className="text-gray-500 mt-4">Se încarcă licitațiile...</p>
        </div>
      ) : auctionList.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">Nu au fost găsite rezultate</p>
        </div>
      ) : (
        <ProjectsByAuctionProvider
          auctionIds={auctionIds}
          enabled={hasActiveSubscription}
        >
          <div className="flex flex-col gap-6">
            {auctionList.map((auction, index) => (
              <React.Fragment key={index}>
                <AuctionItem auction={auction} auctionType={auctionType} />
                {index < auctions.length - 1 && (
                  <hr className="border-t border-dashed border-indigo-200 my-2" />
                )}
              </React.Fragment>
            ))}
          </div>
        </ProjectsByAuctionProvider>
      )}
    </div>
  );
};

export default AuctionList;
